<script>
	import { setContext, onDestroy, onMount } from "svelte";
	import { Flight } from './flight'
	import { enableGlobalOverlay, disableGlobalOverlay } from "../map";

	export let flight
	export let guest = false

	let flightClass

	$: {
		flightClass = new Flight(flight, guest)
		setContext("flight", flightClass);
		window.flight = flightClass
	}
	onMount(() => {
		disableGlobalOverlay()
	})
	onDestroy(() => {
		flightClass.cleanup()
		enableGlobalOverlay()
	})
</script>

<slot/>